var React = require('react');

function ClockIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 0C3.58887 0 0 3.58887 0 8C0 12.4111 3.58887 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58887 12.4111 0 8 0ZM8 15.2057C4.02647 15.2057 0.793985 11.9732 0.793985 8C0.793985 4.02677 4.02647 0.794286 8 0.794286C11.9735 0.794286 15.206 4.02677 15.206 8C15.206 11.9732 11.9735 15.2057 8 15.2057Z","fill":"white","key":0}),React.createElement("path",{"d":"M8.39744 7.83604V3.21349C8.39744 2.99427 8.21969 2.81641 8.00048 2.81641C7.78127 2.81641 7.60352 2.99416 7.60352 3.21349V8.00056C7.60352 8.10582 7.64522 8.20685 7.71971 8.28134L10.254 10.8157C10.3316 10.8932 10.4332 10.932 10.5348 10.932C10.6364 10.932 10.738 10.8932 10.8156 10.8157C10.9705 10.6607 10.9705 10.4092 10.8156 10.2542L8.39744 7.83604Z","fill":"white","key":1})]);
}

ClockIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ClockIcon;

ClockIcon.default = ClockIcon;
